var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 238547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xC3\x8Dcone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.8281 5.17773L40.0025 9.35213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.2227 17.8496L27.3335 21.9604",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.3417 23.8671H21.8438",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.375 23.9102H43.6293",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M39.2852 23.9102H39.5394",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M8.60156 24.4819L10.8901 22.1934",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.668 28.5287L14.9565 26.2402",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.7188 32.5971L19.0072 30.3086",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.8477 36.7084L23.115 34.4199",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M24.8555 40.7123L27.144 38.4238",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M5.36328 28.2324V38.3611C5.36328 39.3571 6.16849 40.1623 7.16441 40.1623H17.2931L5.36328 28.2324Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M45.8548 9.73438C46.8507 9.73438 47.6559 10.5396 47.6559 11.5355V43.2566C47.6559 41.5615 46.2785 40.1841 44.5622 40.1841H28.8817L6.6748 17.9772L5.33984 19.291V11.5355C5.33984 10.5396 6.14506 9.73438 7.14098 9.73438H31.255L23.4571 17.5322C23.2876 17.7017 23.1605 17.9136 23.0969 18.1467L21.4229 23.1263C21.2746 23.5713 21.6984 23.9951 22.1434 23.8256L27.1442 22.0457L27.6103 21.749L39.6038 9.73438H45.8548V9.73438Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M44.582 40.1836H41.4883V46.371H44.582C45.4296 46.371 46.2136 46.0108 46.7645 45.4599C47.3367 44.9089 47.6757 44.1249 47.6757 43.2773C47.6757 41.5609 46.2984 40.1836 44.582 40.1836V40.1836Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M5.35949 19.29L1.63008 23.0194C1.22747 23.4221 1.22747 24.0789 1.63008 24.5027L5.35949 28.2321",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M28.8799 40.1836L30.7446 42.0483L25.7438 47.0491C25.2988 47.4941 24.5995 47.4941 24.1546 47.0491L17.2891 40.1836",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M43.0344 3.90622L41.2545 2.12627C40.5976 1.46939 39.5593 1.4482 38.9236 2.0627L31.2529 9.73341L23.455 17.5313C23.2855 17.7008 23.1584 17.9127 23.0948 18.1458L21.4208 23.1254C21.2725 23.5704 21.6963 23.9942 22.1412 23.8246L27.0785 22.0659C27.2692 22.0023 27.4599 21.8964 27.6082 21.748L39.6016 9.73341L43.098 6.2371C43.7337 5.62259 43.7125 4.5631 43.0344 3.90622V3.90622Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/Planning.5b38ee877a8b73454b04554422129a22.svg";
export { ForwardRef as ReactComponent };